// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2sGnS","actions":"GroupTable_actions__2jNK4","deleteModalFooter":"GroupTable_deleteModalFooter__1ICt2"};